<template>
    <v-container style="max-width:1000px" v-show="store.state.showAlert">
        <p style="color:red">
            <v-row>
                {{ store.state.alertMsg }}
                <v-spacer />
                <v-btn :color="store.state.alertType" text @click="store.state.showAlert = false">x</v-btn>
            </v-row>
        </p>
    </v-container>
</template>

<script>
import store from "../../store";
export default {
    data: () => ({
        store: store,
        name: "alert"
    })
};
</script>

<style></style>
